import React, { useState, useEffect } from 'react';
import { X, Cookie } from 'lucide-react';

const CookieConsent = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [hasConsent, setHasConsent] = useState(false);

  useEffect(() => {
    const consent = localStorage.getItem('cookie-consent');
    if (!consent) {
      setIsVisible(true);
    } else {
      setHasConsent(true);
    }
  }, []);

  const acceptAll = () => {
    localStorage.setItem('cookie-consent', 'all');
    
    // Google Analytics consent update removed as GA is no longer used

    // Trigger Zoho SalesIQ tracking enablement
    if (window.$zoho && window.$zoho.salesiq) {
      if (window.$zoho.salesiq.visitor) {
        try { window.$zoho.salesiq.visitor.tracking('on'); } catch (_) {}
      }
    }

    setHasConsent(true);
    setIsVisible(false);
  };

  const acceptEssential = () => {
    localStorage.setItem('cookie-consent', 'essential');
    
    // Google Analytics consent update removed as GA is no longer used

    // Ensure Zoho SalesIQ tracking is off
    if (window.$zoho && window.$zoho.salesiq) {
      if (window.$zoho.salesiq.visitor) {
        try { window.$zoho.salesiq.visitor.tracking('off'); } catch (_) {}
      }
    }

    setHasConsent(true);
    setIsVisible(false);
  };

  if (!isVisible || hasConsent) {
    return null;
  }

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-card border-t border-border p-4 z-50 animate-fade-in-up shadow-elevated">
      <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4">
        <div className="flex items-center gap-3 flex-1">
          <div className="w-10 h-10 rounded-[10px] bg-brand-tint flex items-center justify-center flex-shrink-0">
            <Cookie className="w-5 h-5 text-brand" />
          </div>
          <div className="text-sm text-foreground/80">
            <p className="font-bold text-foreground mb-1">We use cookies</p>
            <p className="text-xs">
              We use essential cookies to make our site work. With your consent, we may also use non-essential cookies to improve your experience.
            </p>
          </div>
        </div>

        <div className="flex items-center gap-3">
          <button
            onClick={acceptEssential}
            className="px-4 py-2 text-sm text-muted-foreground hover:text-foreground transition-colors"
          >
            Essential only
          </button>
          <button
            onClick={acceptAll}
            className="px-6 py-2 bg-brand hover:bg-brand/90 text-brand-foreground rounded-full text-sm font-bold transition-colors"
          >
            Accept all
          </button>
          <button
            onClick={() => setIsVisible(false)}
            className="p-2 text-muted-foreground hover:text-foreground transition-colors"
          >
            <X className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsent;
